import { graphql } from "@/types/gql";

export const QUERY_PARKING_LOT = graphql(`
  query parkingLots($cityId: String!) {
    parkingLots(cityId: $cityId) {
      id
      geometry
      position
      name
      address
      note
      cityId
      curbZoneIds
    }
  }
`);

export const QUERY_ADD_PARKING_LOT = graphql(`
  mutation createParkingLot($input: CreateParkingLotInput!) {
    createParkingLot(input: $input) {
      id
      geometry
      position
      name
      address
      note
      cityId
      curbZoneIds
    }
  }
`);

export const QUERY_UPDATE_PARKING_LOT = graphql(`
  mutation updateParkingLot($input: UpdateParkingLotInput!) {
    updateParkingLot(input: $input) {
      id
      geometry
      position
      name
      address
      note
      cityId
      curbZoneIds
    }
  }
`);

export const QUERY_DELETE_PARKING_LOT = graphql(`
  mutation deleteParkingLot($id: String!) {
    deleteParkingLot(id: $id) {
      id
    }
  }
`);
